
<script>
  import LocalStorage from "../localstorage.js";

  const localStorageApi = new LocalStorage("notification_");
  let notifications = [];

function fetchNotifications() {
    notifications = localStorageApi.getAll();
  }


  fetchNotifications();
</script>

<style>
  .sidebar {
    width: 250px;
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;
    background-color: #f1f1f1;
    padding: 20px;
    overflow-y: auto;
  }
  .notification {
    padding: 10px;
    margin-bottom: 10px;
    color: black;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
</style>

<div class="sidebar">
  <h2>Notifications</h2>
  {#each notifications as notification}
    <div class="notification">
      <h4>{notification.title}</h4>
      <p>{notification.description}</p>
      <small>{notification.timestamp}</small>
    </div>
  {/each}
</div>
